import { colors, typography } from "../../../design/tokens";
import { RankingsAllResponse, StoreType } from "../../../model/rankings";
import { AppStoreRankingColumn } from "./AppStoreRankingColumn";

interface AppStoreRankingsGridProps {
  rankings: RankingsAllResponse;
  store: StoreType;
  country: string;
}

export function AppStoreRankingsGrid({
  rankings,
  store,
  country,
}: AppStoreRankingsGridProps) {
  return (
    <div className="grid grid-cols-3 gap-8">
      <div>
        <h2 className={`${typography.size.lg} ${typography.weight.semibold} ${colors.text.primary} mb-4 px-3`}>Free</h2>
        <AppStoreRankingColumn
          apps={rankings.free}
          store={store}
          country={country}
        />
      </div>
      <div>
        <h2 className={`${typography.size.lg} ${typography.weight.semibold} ${colors.text.primary} mb-4 px-3`}>Paid</h2>
        <AppStoreRankingColumn
          apps={rankings.paid}
          store={store}
          country={country}
        />
      </div>
      <div>
        <h2 className={`${typography.size.lg} ${typography.weight.semibold} ${colors.text.primary} mb-4 px-3`}>Grossing</h2>
        <AppStoreRankingColumn
          apps={rankings.grossing}
          store={store}
          country={country}
        />
      </div>
    </div>
  );
}
